import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

function CreateQRCodePage() {
  const [selectedBar, setSelectedBar] = useState("");
  const [bars, setBars] = useState([]);

  const [qrVisible, setQrVisible] = useState(false);

  const qrRef = useRef(null);

  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/admin");
  };

  const qrUrl = selectedBar
    ? `http://vision.org.gr/menu/${encodeURIComponent(selectedBar)}`
    : "";

  // Load bars dynamically from API
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/bars`)
      .then((res) => res.json())
      .then((data) => setBars(data))
      .catch((err) => console.error("Error fetching bars:", err));
  }, []);

  const handleGenerate = () => {
    if (selectedBar) {
      setQrVisible(true);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(qrUrl);
      alert("Link copied to clipboard!");
    } catch (err) {
      alert("Failed to copy.");
    }
  };

  const handleDownload = async () => {
    if (!qrRef.current) return;
    html2canvas(qrRef.current).then((canvas) => {
      const link = document.createElement("a");
      link.download = `qr-code-${selectedBar}.png`;
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  return (
    <div style={styles.container}>
      {/* Back Button */}
      <button style={styles.back} onClick={handleBack}>←</button>
      <h1 style={styles.title}>Create QR Code for Bar</h1>

      <div style={styles.card}>
        <label style={styles.label}>Select Cocktail Bar</label>
        <select
          value={selectedBar}
          onChange={(e) => setSelectedBar(e.target.value)}
          style={styles.select}
        >
          <option value="" disabled>
            Select a bar
          </option>
          {bars.map((bar) => (
            <option key={bar.id} value={bar.name}>
              {bar.name}
            </option>
          ))}
        </select>

        <button
          style={styles.button}
          onClick={handleGenerate}
          disabled={!selectedBar}
        >
          Generate QR Code
        </button>

        {qrVisible && (
          <>
            <div ref={qrRef} style={styles.qrBox}>
              <QRCode
                value={qrUrl}
                size={180}
                bgColor="#ffffff"
                fgColor={blue}
              />
            </div>
            <p style={styles.qrText}>{qrUrl}</p>
            <button style={styles.copyButton} onClick={handleCopy}>
              Copy QR Link
            </button>
            <button style={styles.copyButton} onClick={handleDownload}>
              Download QR Code as Image
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: blue,
    minHeight: "100vh",
    padding: "60px 20px",
    fontFamily: "'Segoe UI', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: yellow,
  },
  title: {
    fontSize: "30px",
    marginBottom: "30px",
    textAlign: "center",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "30px",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    color: blue,
  },
  label: {
    fontWeight: "500",
    fontSize: "15px",
  },
  select: {
    padding: "12px",
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    outline: "none",
  },
  button: {
    padding: "12px",
    backgroundColor: yellow,
    color: blue,
    fontWeight: "bold",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  qrBox: {
    display: "inline-block", // IMPORTANT for html2canvas
    textAlign: "center",
    padding: "10px",
    backgroundColor: "#ffffff",
  },
  qrText: {
    fontSize: "13px",
    textAlign: "center",
    wordBreak: "break-all",
    marginTop: "10px",
  },
  copyButton: {
    marginTop: "8px",
    fontSize: "14px",
    color: blue,
    backgroundColor: "transparent",
    border: `2px solid ${blue}`,
    borderRadius: "8px",
    padding: "8px 12px",
    cursor: "pointer",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
};

export default CreateQRCodePage;